import React, { useState, useEffect } from "react"
import { useTranslation } from 'react-i18next'
import Field from "shared/components/forms/field"
import SectionComponent from "./SectionComponent"
import {OS_HCP_BRAND} from "../helper/registration"

const JoinOpinionSiteComponent = (props) => {

    const { t } = useTranslation()
    const [joinOS, setJoinOS] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const joinOSChecked = () =>
    {
        setJoinOS(previousState => {
            if(!previousState){
                setIsLoading(true)
                props.getOtherBrandAttributesList(OS_HCP_BRAND)
            }
            props.selectJoinOS(!previousState)
            return !previousState
        })
    }

    useEffect(() => {
        if(!joinOS){
            props.setAttributes([])
            props.setJoinedOtherBrandId(0)
        } else {
            props.setJoinedOtherBrandId(OS_HCP_BRAND)
        }
    }, [joinOS])


    useEffect(() => {
        if(!joinOS && props.attributes != undefined){
            if(Object.keys(props.attributes).length > 0)
            {
                props.setAttributes([])
            }
        }
        setIsLoading(false)
    }, [props.attributes])

    return (
        <div className="major-sections">
            <div className="join-second-brand">
                <div className="join-brand-separator" />
                <div id="termsservice">
                    <Field
                        type="checkbox"
                        label={t('register.receive_os_opportunities')}
                        id="join-incrowd"
                        checked={joinOS}
                        labelClass='join-brand-label'
                        onChange={() => {
                            joinOSChecked()
                        }}
                    />
                </div>

                <div className="join-ic-container">
                    <a className={`logo-registration-join-ic os-logo-join-brand`}>OpinionSite</a>
                    <p>{t('register.join_os_brand_description')}</p>
                </div>
            </div>
            {isLoading && <img className="loader" src={props.spinnerSrc} />}
            {!isLoading && joinOS && props.attributes['ic'] != undefined && props.attributes['ic'].length > 0 &&
                <SectionComponent key={'ic'}
                    id={'ic'}
                    name={t('form.partner_additional_info')}
                    attributes={props.attributes}
                    setAttributes={props.setAttributes}
                    highlightErrors={props.highlightErrors}/>
            }
        </div>
    )
}

export default JoinOpinionSiteComponent